module.exports = __webpack_public_path__ + "img/商城.e3701340.png";